export const model = {
    fields: {
        name: {
            isRequired: true
        },
        code: {
            isRequired: true
        },
        density: {
            isRequired: true
        },
        price: {
            isRequired: true
        },
    }
}